<div class="dialog-container">
  <div class="dialog-header">
    <h2>Add New Institution</h2>
    <span class="cancel-btn" (click)="onCancel()"> 
	<img src="assets/images/close_button.svg">	
	</span>
  </div>

  <p class="dialog-subtitle">
    Enter the details of the new institution to add to the platform.
  </p>

  <form [formGroup]="addInstitutionForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>Institution Name</label>
      <input
        type="text"
        formControlName="name"
        placeholder="e.g., Stanford Institute"
      />
    </div>

    <div class="form-group">
      <label>Domain</label>
      <input type="text" formControlName="domain" placeholder="e.g., sit.ac.in" />
    </div>

    <div class="form-group">
      <label>Admin Email</label>
      <input
        type="email"
        formControlName="email"
        placeholder="admin@institution.com"
      />
    </div>

    <div class="form-group">
      <label>Subscription Plan</label>
      <select formControlName="plan">
        <option value="" disabled selected>Select a plan</option>
        <option *ngFor="let plan of plans" [value]="plan">{{ plan }}</option>
      </select>
    </div>

    <div class="text-end">
      <button type="button" class="btn-add2 me-3" (click)="onCancel()">Cancel</button>
      <button type="submit" class="btn-add" [disabled]="addInstitutionForm.invalid">
        Add Institution
      </button>
    </div>
  </form>
</div>
